var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../../api/axios";
import { OpenBalanceTexts } from "./openBalance-enums";
/**
 * Function to fetch open balance page data for a specific order number.
 *
 * @param orderNumber - The order number for which the open balance page data is to be retrieved.
 * @returns A Promise resolving to `GetOpenBalancePageDataReturnType` containing the queried data,
 *          or `null` if an error occurs during the request.
 */
export const getOpenBalancePageData = (orderNumber) => __awaiter(void 0, void 0, void 0, function* () {
    // Make a GET request to fetch the open balance page data for the given order number
    const queryData = yield axiosPrivate
        .get(`/Account/GetOpenBalancePageData?orderNumber=${orderNumber}`)
        .then((res) => res.data) // Extract the data from the response
        .catch((e) => {
        return null; // Return null if an error occurs
    });
    // Return the fetched data wrapped in an object
    return {
        queryData,
    };
});
/**
 * Function to process a payment request.
 *
 * @param request - The payment request object containing the necessary details.
 * @returns A Promise resolving to `ProcessPaymentResponse` if the payment is successful.
 * @throws An error if the payment fails or if there is an issue with the request.
 */
export const processPayment = (request) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // Send the payment request to the server
        const paymentResponse = yield axiosPrivate.post(`/Account/ProcessPayment`, request // Send the request object as the body
        );
        // Check if the response status is not 200 (success)
        if (paymentResponse.status !== 200) {
            throw new Error(OpenBalanceTexts.PAYMENT_FAILED);
        }
        // Return the payment response data
        return paymentResponse.data;
    }
    catch (error) {
        throw new Error(OpenBalanceTexts.PAYMENT_ERROR); // Throw a generic payment error
    }
});
